import { NgModule } from 'angular-ts-decorators';
import { moduleName } from '../constants';

import { HeroCustomizerV2FilterCheckboxComponent } from './hero-customizer-v2.filter-checkbox.component';
import { HeroCustomizerV2FilterColorComponent } from './hero-customizer-v2.filter-color.component';
import { HeroCustomizerV2FilterRadioComponent } from './hero-customizer-v2.filter-radio.component';
import { HeroCustomizerV2FiltersComponent } from './hero-customizer-v2.filters.component';

import { OnlyVisibleOptionsPipe } from './only-visible-options.pipe';

@NgModule({
  declarations: [
    HeroCustomizerV2FilterCheckboxComponent,
    HeroCustomizerV2FilterColorComponent,
    HeroCustomizerV2FilterRadioComponent,
    HeroCustomizerV2FiltersComponent,

    OnlyVisibleOptionsPipe,
  ],
  id: `${moduleName}.filtering`,
  providers: [],
})
export class HeroCustomizerV2FilteringModule {
}
